import { locales, type Locale } from "./content"

/*
 * Public paths per language, small enough for the browser bundle. English
 * lives at the root (/, /cv, /projects/nexo); Portuguese and German under
 * /pt and /de.
 */

export const isLocale = (value: string): value is Locale => (locales as string[]).includes(value)

/** The public path of a page in a language. */
export function localePath(locale: Locale, path = "/"): string {
  const p = path.startsWith("/") ? path : `/${path}`
  if (locale === "en") return p
  return p === "/" ? `/${locale}` : `/${locale}${p}`
}

/** A public path without its language prefix, and the language it was in. */
export function splitLocale(pathname: string): { locale: Locale; path: string } {
  const [, first, ...rest] = pathname.split("/")
  // /en/... is how the server sees the unprefixed English pages (a rewrite).
  if (first && isLocale(first)) {
    return { locale: first, path: `/${rest.join("/")}` }
  }
  return { locale: "en", path: pathname || "/" }
}
